import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchAllMasterData } from '../../apis/master/getAllMasterData.api';

// Async thunk to fetch all master data
export const fetchMasterData = createAsyncThunk(
    'masterData/fetchMasterData',
    async (_, { rejectWithValue }) => {
        try {
            const data = await fetchAllMasterData();
            return data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    },
);

const masterDataSlice = createSlice({
    name: 'masterData',
    initialState: {
        countries: [],
        sectors: [],
        regions: [],
        cpvCodes: [],
        fundingAgencies: [],
        states: [],
        loading: false,
        error: null,
        lastFetched: null,
    },
    reducers: {
        clearMasterData: (state) => {
            state.countries = [];
            state.sectors = [];
            state.regions = [];
            state.cpvCodes = [];
            state.fundingAgencies = [];
            state.states = [];
            state.lastFetched = null;
        },
        updateCountries: (state, action) => {
            state.countries = action.payload;
        },
        updateSectors: (state, action) => {
            state.sectors = action.payload;
        },
        updateRegions: (state, action) => {
            state.regions = action.payload;
        },
        updateCPVCodes: (state, action) => {
            state.cpvCodes = action.payload;
        },
        updateFundingAgencies: (state, action) => {
            state.fundingAgencies = action.payload;
        },
        updateStates: (state, action) => {
            state.states = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchMasterData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchMasterData.fulfilled, (state, action) => {
                state.loading = false;
                state.countries = action.payload.countries;
                state.sectors = action.payload.sectors;
                state.regions = action.payload.regions;
                state.cpvCodes = action.payload.cpvCodes;
                state.fundingAgencies = action.payload.fundingAgencies;
                state.states = action.payload.states;
                state.lastFetched = new Date().toISOString();
            })
            .addCase(fetchMasterData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const {
    clearMasterData,
    updateCountries,
    updateSectors,
    updateRegions,
    updateCPVCodes,
    updateFundingAgencies,
    updateStates,
} = masterDataSlice.actions;

export default masterDataSlice.reducer;
